"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  voyagePlanSearch: {
    title: '船期 / 船期查询',
    polZH: '起运港',
    podZH: '目的港',
    startDate: '起始日期',
    withinOneWeek: '及后一周内',
    withinTwoWeek: '及后两周内',
    withinThreeWeek: '及后三周内',
    withinFourWeek: '及后四周内',
    tips_1: '温馨提示：',
    tips_2: '（1） 船期仅供参考，如有疑问，请与我司当地代理联系。',
    tips_4: '（2） ETD：预计离港时间； ETA：预计到达时间',
    tips_5: '（3） CTD：实际离港时间； CTA：实际到达时间',
    lane: '航线',
    vessel: '航名/航次',
    terminal: 'Terminal',
    polEN: 'POL',
    podEN: 'POD',
    etd: '离港时间',
    eta: '到港时间',
    sailingTime: '在途',
    day: '天',
    transfer: '中转',
    hour: '小时',
    transshipment: '次转运',
    resultTips_1: '未查询到直航船期，',
    resultTips_2: '点击跳转中转查询',
    resultTips_3: '暂无请求数据',
    etd1: '（预计离港时间）',
    etb1: '（预计到港时间）',
    showDetail: '显示详情',
    hideDetail: '隐藏详情',
    subscribe: '订阅',
    subscribeSuccess: '订阅成功',
    subscribeTips: '提示',
    sure: '确认',
    unsubscribe: '取消订阅(Unsubscribe)',
    unsubscribeSuccess: '取消订阅成功(Unsubscribed successfully)'
  }
};